import React from 'react';
import { mockData } from '../utils/mockData'; // Adjust path as necessary

const MenuPage = () => {
  return (
    <div className="menu-page">
      <h1 className='font-bold my-6 text-2xl'>{}</h1>
      
    </div>
  );
};

export default MenuPage;
